<template>
  <div class="flex items-center flex-wrap md:flex-nowrap" :class="{ light }">
    <span
      v-if="!hideRootText"
      class="header-link"
      @click.stop="handleClick({ id: 'root' })"
      >{{ rootText }}</span
    >
    <div
      v-for="(crumb, i) in crumbs"
      :key="crumb.id"
      class="flex items-center"
      :class="crumb.className"
      @click.stop="handleClick(crumb)"
    >
      <i
        v-if="i > 0 || !hideRootText"
        class="fas fa-chevron-right mx-1 header-icon"
      />
      <span
        class="crumb"
        :class="{ 'font-bold': isLastCrumb(i), 'header-link': !isLastCrumb(i) }"
      >
        {{ crumb.label }}
      </span>
      <span v-if="crumb.hint" class="font-italic ml-1 hint-crumb"
        >({{ crumb.hint }})</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "Breadcrumbs",
  props: {
    crumbs: {
      type: Array,
      default: () => []
    },
    hideRootText: {
      type: Boolean,
      default: false
    },
    rootText: {
      type: String,
      default: "Home"
    },
    light: {
      type: Boolean,
      default: false
    }
  },
  emits: ["click"],
  methods: {
    handleClick(crumb) {
      this.$emit("click", crumb);
    },
    isLastCrumb(index) {
      return index === this.crumbs.length - 1;
    }
  }
};
</script>

<style lang="scss" scoped>
.fa-chevron-right {
  font-size: 0.6em;
}
.crumb {
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
  text-overflow: ellipsis;
  color: var(--text-color-ss);
}

.hint-crumb {
  text-transform: capitalize;
}

.light {
  .crumb,
  .header-link,
  .header-icon {
    color: var(--white) !important;
  }
}
</style>
